module.exports = __webpack_public_path__ + "static/img/ground31.7ce0eb23.png";